// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import "./index.css"; // Tailwind styles
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
